/**
 * Turns a path relative to the app root into an absolute one. The app root is not the domain root
 * when the app is embedded in the dashboard at /preview/ (see src/html/preview.html), so anything
 * loaded outside of react-router (workers, assets) has to go through here.
 *
 * Only safe to call after setupHistory() has run.
 *
 * @param {string} path - Path relative to the app root.
 * @return {string} - Absolute path including the base path the app is served from.
 */
export default function appPath(path) {
    return `${app.history.basename}/${path}`.replace(/\/{2,}/g, '/');
}
